export enum RdStationTag {
    PARCEIRO_AFILIADO = 1,
    CLIENTE_MEU_CONSULTORIO = 2,
    CONVERTIDO = 3,
    COLABORADOR_MEU_CONSULTORIO = 4,
}
